import { IThemeAssetContributor } from '../ThemeAssetContributor';

export class Theme11ThemeAssetContributor implements IThemeAssetContributor {
    getAssetUrls(): string[] {
        return [''];
    }
}
